import React from 'react';
import styled from 'styled-components';

const SeparatorContainer = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e2e8f0;
  margin: 16px 0;
`;

export function Separator() {
  return <SeparatorContainer />;
}
